import { Event } from '@/modules/tracking/types'
class PageViewEvent extends Event {
  constructor() {
    super('Pageview', 'Seite angesehen', '')
  }
}

export const PageView = new PageViewEvent()
